import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { ImageModalComponent } from '../../../app/content/layout/components/modals/image-modal/image-modal.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<ImageModalComponent> = {
  title: 'Molecules/Modals/Image Modal',
  component: ImageModalComponent,
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<ImageModalComponent>;

export const Default: Story = {
  args: {
    title: 'Château Margaux 2020',
    imgSrc: 'https://picsum.photos/600/800',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-image-modal')).toBeTruthy();
  },
};

export const LandscapeImage: Story = {
  args: {
    title: 'Barolo Riserva 2018',
    imgSrc: 'https://picsum.photos/800/600',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-image-modal')).toBeTruthy();
  },
};
